/** OCU cart quantity loading overlay — pending-fetch counter + DOM quiescence + cart reconciliation */
(function() {
  var OCU_SELECTORS = [
    '.ocu-cart-drawer', '.ocu-incart-drawer', '#ocu-incart-drawer',
    '.ocu-incart-sidebar', '.ocu-sidecart', '[data-ocu-incart]', '.zipify-ocu-incart'
  ];
  var OCU_QTY_BTNS = '.ocu-quantity-minus, .ocu-quantity-plus, .ocu-cart-line-item-remove';
  var QUIESCENCE_MS = 600;
  var SAFETY_MS = 12000;

  var overlay = document.createElement('div');
  overlay.className = 'nn-cart-loading-overlay';
  var spinner = document.createElement('div');
  spinner.className = 'nn-cart-loading-spinner';
  overlay.appendChild(spinner);

  var pendingFetches = 0;
  var quiescenceTimer = null;
  var safetyTimer = null;
  var domObserver = null;
  var _reconciling = false;

  function findContainer() {
    for (var i = 0; i < OCU_SELECTORS.length; i++) {
      try { var el = document.querySelector(OCU_SELECTORS[i]); if (el) return el; } catch(e) {}
    }
    return null;
  }

  function show() {
    var c = findContainer();
    if (!c) return;
    if (overlay.parentNode !== c) {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      c.appendChild(overlay);
      if (getComputedStyle(c).position === 'static') c.style.position = 'relative';
    }
    overlay.style.display = 'block';
    clearTimeout(safetyTimer);
    safetyTimer = setTimeout(forceHide, SAFETY_MS);
    startObserver(c);
  }

  function maybeHide() {
    if (pendingFetches > 0) return;
    clearTimeout(quiescenceTimer);
    quiescenceTimer = setTimeout(function() {
      if (pendingFetches === 0) hide();
    }, QUIESCENCE_MS);
  }

  function hide() {
    clearTimeout(safetyTimer);
    clearTimeout(quiescenceTimer);
    stopObserver();
    overlay.style.display = 'none';
  }

  function forceHide() { pendingFetches = 0; hide(); }

  function trackFetch(fetchFn, input, init) {
    return fetchFn.call(window, input, init)
      .then(function(r) { pendingFetches = Math.max(0, pendingFetches - 1); maybeHide(); return r; })
      .catch(function(err) { pendingFetches = Math.max(0, pendingFetches - 1); maybeHide(); throw err; });
  }

  function startObserver(container) {
    stopObserver();
    domObserver = new MutationObserver(function(mutations) {
      var hasReal = mutations.some(function(m) {
        return Array.prototype.some.call(m.addedNodes, function(n) { return n !== overlay; })
            || m.removedNodes.length > 0;
      });
      if (!hasReal) return;
      clearTimeout(quiescenceTimer);
      if (pendingFetches === 0) {
        quiescenceTimer = setTimeout(function() {
          if (pendingFetches === 0) hide();
        }, QUIESCENCE_MS);
      }
    });
    domObserver.observe(container, { childList: true, subtree: true });
  }

  function stopObserver() {
    if (domObserver) { domObserver.disconnect(); domObserver = null; }
  }

  // Fetch actual Shopify cart, merge any items absent from OCU's update payload
  function reconcileAndTrack(nativeFetch, input, init) {
    if (_reconciling) return trackFetch(nativeFetch, input, init);
    _reconciling = true;

    var cartPromise = nativeFetch.call(window, '/cart.js')
      .then(function(r) { return r.json(); })
      .catch(function() { return null; });

    return cartPromise.then(function(actualCart) {
      _reconciling = false;
      var finalInit = init;
      try {
        if (actualCart && actualCart.items && actualCart.items.length > 0 &&
            init && typeof init.body === 'string') {
          var body = JSON.parse(init.body);
          if (body && body.updates && typeof body.updates === 'object' && !Array.isArray(body.updates)) {
            var merged = false;
            actualCart.items.forEach(function(item) {
              var vid = String(item.variant_id);
              if (!(vid in body.updates)) {
                body.updates[vid] = item.quantity;
                merged = true;
                console.log('[nn-cart-loader] Reconciled missing item:', item.title, 'qty:', item.quantity);
              }
            });
            if (merged) {
              finalInit = Object.assign({}, init, { body: JSON.stringify(body) });
            }
          }
        }
      } catch(e) { console.warn('[nn-cart-loader] Reconcile error:', e); }
      return trackFetch(nativeFetch, input, finalInit);
    }).catch(function() {
      _reconciling = false;
      return trackFetch(nativeFetch, input, init);
    });
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest(OCU_QTY_BTNS)) show();
  }, true);

  function patchFetch() {
    if (window._nnFetchPatched) return;
    window._nnFetchPatched = true;
    var _f = window.fetch;
    window.fetch = function(input, init) {
      var url = typeof input === 'string' ? input : ((input || {}).url || '');
      if (/\/cart\/update/.test(url)) {
        pendingFetches++;
        show();
        return reconcileAndTrack(_f, input, init);
      } else if (/\/cart\/change/.test(url)) {
        pendingFetches++;
        show();
        return trackFetch(_f, input, init);
      } else if (/\/cart\.js($|\?)/.test(url) && overlay.style.display === 'block') {
        if (_reconciling) return _f.apply(window, arguments);
        pendingFetches++;
        return trackFetch(_f, input, init);
      }
      return _f.apply(window, arguments);
    };
  }

  patchFetch();
  window.addEventListener('load', patchFetch);
})();
